<template>
    <div class="register">
        <indexHeader/>
        <div class="wrapper">
            <div class="title">猎豹实训平台企业版/学校版 试用登记表</div>
            <Form :model="registerForm" :rules="rulesRegisterForm"  label-position="top" class="register-form">
                <FormItem label="企业/学校 名称" prop="school">
                    <Input v-model="registerForm.school"></Input>
                </FormItem>
                <FormItem label="您的姓名" prop="name">
                    <Input v-model="registerForm.name"></Input>
                </FormItem>
                <FormItem label="职务" prop="post">
                    <div class="info">
                        <p>面向企业及学校提供，仅接受企业/学校相关人员、老师申请。<br>学生或在职人员如果是个人学习使用，无需申请，直接登录学习即可。</p>
                    </div>
                    <Input v-model="registerForm.post"></Input>
                </FormItem>
                <FormItem label="电话" prop="tel">
                    <Input v-model="registerForm.tel"></Input>
                </FormItem>
                <FormItem label="微信/QQ号" prop="qq">
                    <Input v-model="registerForm.qq"></Input>
                </FormItem>
                <FormItem label="邮箱地址" prop="email">
                    <Input v-model="registerForm.email"></Input>
                </FormItem>
                <FormItem label="需求简述" prop="remarks">
                    <Input v-model="registerForm.remarks" type="textarea" :autosize="{minRows: 2,maxRows: 5}" ></Input>
                </FormItem>
                <FormItem style="text-align: center">
                    <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
                </FormItem>
            </Form>
        </div>
    </div>
</template>

<script>
    import indexHeader from "../newLogin/loginHeader";

    export default {
        name: "register",
        components: {
            indexHeader
        },
        data () {
            return {
                registerForm: {
                    school:'',
                    name:'',
                    post:'',
                    tel:'',
                    qq:'',
                    email:'',
                    remarks:'',
                },
                rulesRegisterForm:{
                    school: [
                        { required: true, message: '请输入企业/学校的名称!', trigger: 'blur' }
                    ],
                    name: [
                        { required: true, message: '请输入您的名称！', trigger: 'blur' }
                    ],
                    post: [
                        { required: true, message: '请输入您的职务！', trigger: 'blur' }
                    ],
                    tel: [
                        { required: true, message: '请输入您的联系方式！', trigger: 'blur' }
                    ],
                    qq: [
                        { required: true, message: '请输入您的QQ/微信号！', trigger: 'blur' }
                    ],
                    email: [
                        { required: true, message: '请输入邮箱地址！', trigger: 'blur' }
                    ],
                    remarks: [
                        { required: true, message: '请输入需求简述！', trigger: 'blur' }
                    ],
                }
            }
        }

    }
</script>

<style scoped lang="less">
.register{
    background: #EDF0F8;
    padding-top: 73px;
    overflow: hidden;
    .wrapper{
        width: 800px;
        margin: 30px auto;
        background: #ffffff;
        .title{
            background:#1479f2 ;
            color: #ffffff;
            text-align: center;
            height: 63px;
            line-height: 63px;
            font-size: 24px;
            font-weight: 700;
        }
    }
    .register-form{
        width: 80%;
        padding: 30px;
        .info{
            p{
                font-size: 14px;
                line-height: 18px;
                margin-bottom: 6px;
            }
        }

    }
}
</style>